module.exports = __webpack_public_path__ + "static/desk-5f02f1b9e9cd6d527af1c2f990c91e10.svg";